import React from "react";
import EditOtherExpenses from "../../../Features/Forms/OtherExpenses/Edit";

const Edit = () => {
  return (
    <div>
      <EditOtherExpenses />
    </div>
  );
};

export default Edit;
